var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('button',{staticClass:"delete-btn",on:{"click":_vm.handle}},[_vm._v("Werk löschen")]),_c('confirm-dialog',{ref:"confirmDialogue"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }